export const PHOTOGRAPHIC_TASK = 'photopgraphic'

export const acceptedImageFormat =
    '.apng,.avif,.gif,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.svg,.webp,.bmp,.ico,.cur,.tif,.tiff.APNG,.AVIF,.GIF,.JPG,.JPEG,.JFIF,.PJPEG,.PJP,.PNG,.SVG,.WEBP,.BMP,.ICO,.CUR,.TIF,.TIFF'

export interface PhotoGallery {
    attachmentType: string
    contentType: string
    creatorUserInfo: { firstname: string; lastname: string; nickname?: string, userId: string }
    ext: string
    fixtureCount: number
    insertDate: number
    lastupdate: number
    macroarea: string
    name: string
    reference: { projectId: string; storeId: string }
    status: string
    type: string
    url: string
    urlThumbnail: string
    _id: string
}

export interface IPhotoDetails {
    _id: string
    fileRef: string
    type: string
    attachmentType: string
    tags: { name: string; x: number; y: number }[]
    contentType: string
    url: string
    urlThumbnail: string
    name: string
    ext: string
    insertDate: number
    creatorUserInfo: {
        firstname: string
        lastname: string
        nickname?: string
        userId: string
    }
    status: string
    lastupdate: number
    fixtureCount: 1
    macroarea: string
    reference: {
        projectId: string
        storeId: string
    }
    store: {
        storeId: string
        globalStoreId: string
        banner: string
        bannerDesc: string
        storeName: string
        address: string
        city: string
        stateProvince: string
        country: string
        macroregion: string
        segment: string
        geoLatitude: string
        geoLongitude: string
        storeLocation: string
        channelOfTrade: string
        macroregionDesc: string
        region: string
        businessModel: string
        storeHostName: string
        zoneDesc: string
        market: string
        marketingSegment: string
    }
    project: {
        id: string
        title: string
        type: string
        status: string
        childrenSubType: string
    }

    publishedUserData: {
        data: number
        name: string
        lastname: string
        nickname?: string
        role: string
        userId: string
    }
}

export enum SearchByValues {
    USER_ID = 'userId',
    STORE_ID = 'storeId',
}
